<template>
    <span v-if="finalViewonly">{{ value }}</span>
    <input
        v-else
        :class="prefixCls"
        :value="value"
        :disabled="finalDisabled"
        :readonly="finalReadonly"
        v-bind="$attrs"
        @change="handleChange"
        @input="handleInput"
        @blur="handleBlur"
    >
</template>
<script>
import { findComponentUpward } from "../../utils/assist"
import Field from "../../mixins/field"

const prefixCls = "base-input"

export default {
    name: "Input",
    
    inheritAttrs: false,
    
    mixins: [Field],
    props: {
        value: {
            type: [String, Number],
            default: ""
        },
    },
    data() {
        return {
            prefixCls: prefixCls,
        }
    },
    methods: {
        handleBlur(event) {
            this.$emit("on-blur", event)
            if (
                !findComponentUpward(this, [
                    "DatePicker",
                    "TimePicker",
                    "Cascader",
                    "Search"
                ])
            ) {
                this.dispatchFormBlur(this.currentValue)
            }
        },
        handleInput(event) {
            let value = event.target.value
            this.$emit("input", value)
            if (
                !findComponentUpward(this, [
                    "DatePicker",
                    "TimePicker",
                    "Cascader",
                    "Search"
                ])
            ) {
                this.dispatchFormChange(value)
            }
        },
        handleChange(event) {
            this.$emit("on-input-change", event)
        },
    },
}
</script>